import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Redirect, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { VccTransactionsExportPage } from './VccTransactionsExportPage';

export interface VccRoutingProps extends RouteComponentProps {}

export const VccRoutingComponent = (props: VccRoutingProps) => {
  return (
    <Switch>
      <>
        <Route
          path={`${props.match.path}/export`}
          component={VccTransactionsExportPage}
          exact
        />
        <Redirect from={`${props.match.path}/`} to={`${props.match.path}/export`} />
      </>
    </Switch>
  );
};

export const VccRouting = compose(withRouter)(VccRoutingComponent);
